<template>
  <v-app class="app-bg">
    <!-- Sidebar -->
    <v-navigation-drawer v-model="drawer" app clipped width="230" class="sidebar">
      <v-list dense nav class="px-3 mt-4">
        <v-list-item
          v-for="item in menuItems"
          :key="item.title"
          :to="item.to"
          link
          class="mb-1 nav-item"
          :class="{ 'nav-item--active': isActive(item.to) }"
          active-class="nav-item--active"
        >
          <v-list-item-icon class="mr-3 my-auto">
            <v-icon size="18">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-body-2">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <!-- Support Card -->
        <div class="px-4 mb-4">
          <v-card class="rounded-lg pa-4" style="background: rgba(45, 212, 160, 0.08); border: 1px solid rgba(45, 212, 160, 0.15)">
            <div style="color: #9CA3AF; font-size: 12px" class="mb-2">
              Precisa de ajuda?
            </div>
            <div class="white--text text-body-2 mb-3">
              Entre em contato com o suporte
            </div>
            <v-btn small color="#2DD4A0" dark block class="text-none" style="border-radius: 8px">
              Contato
            </v-btn>
          </v-card>
        </div>

        <v-list dense nav class="px-3 pb-4">
          <v-list-item to="/settings" class="mb-1 nav-item">
            <v-list-item-icon class="mr-3 my-auto"><v-icon size="18">mdi-cog-outline</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title class="text-body-2">Configurações</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item @click="logout" class="nav-item">
            <v-list-item-icon class="mr-3 my-auto"><v-icon size="18">mdi-logout</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title class="text-body-2">Sair</v-list-item-title></v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>

    <!-- Top Bar -->
    <v-app-bar app clipped-left flat class="topbar" height="60">
      <v-app-bar-nav-icon @click="drawer = !drawer" color="#9CA3AF" />
      <img src="/logo.png" alt="WayBuilder" style="height: 32px" class="ml-2" />
      <v-spacer />

      <!-- Search -->
      <v-text-field
        placeholder="Buscar..."
        prepend-inner-icon="mdi-magnify"
        dense
        outlined
        hide-details
        dark
        color="#2DD4A0"
        background-color="#2A2F3E"
        style="max-width: 250px; border-radius: 10px"
        class="mr-4"
      />

      <v-btn icon class="mr-1">
        <v-icon color="#9CA3AF" size="20">mdi-email-outline</v-icon>
      </v-btn>
      <v-btn icon class="mr-2">
        <v-badge color="#2DD4A0" dot overlap>
          <v-icon color="#9CA3AF" size="20">mdi-bell-outline</v-icon>
        </v-badge>
      </v-btn>

      <v-divider vertical class="mx-2" style="border-color: rgba(255,255,255,0.06)" />

      <v-menu offset-y nudge-bottom="8">
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on" class="text-none ml-1">
            <v-avatar size="32" color="#2DD4A0" class="mr-2">
              <span class="white--text text-caption font-weight-bold">{{ userInitials }}</span>
            </v-avatar>
            <span class="white--text text-body-2">{{ userName }}</span>
            <v-icon small color="#9CA3AF" class="ml-1">mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list dense style="background: #2A2F3E">
          <v-list-item to="/settings">
            <v-list-item-icon><v-icon small>mdi-cog</v-icon></v-list-item-icon>
            <v-list-item-title>Configurações</v-list-item-title>
          </v-list-item>
          <v-divider style="border-color: rgba(255,255,255,0.06)" />
          <v-list-item @click="logout">
            <v-list-item-icon><v-icon small color="#EF5350">mdi-logout</v-icon></v-list-item-icon>
            <v-list-item-title>Sair</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- Content -->
    <v-main class="main-bg">
      <v-container fluid class="pa-6">
        <slot />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import authService from '../services/auth.service'

export default {
  name: 'DefaultLayout',
  data() {
    return {
      drawer: true,
      menuItems: [
        { title: 'Dashboard', icon: 'mdi-view-dashboard-outline', to: '/' },
        { title: 'API Keys', icon: 'mdi-key-variant', to: '/api-keys' },
        { title: 'Logs de Uso', icon: 'mdi-chart-bar', to: '/usage-logs' },
        { title: 'Planos', icon: 'mdi-credit-card-outline', to: '/plans' },
        { title: 'Alertas', icon: 'mdi-bell-ring-outline', to: '/alerts' },
        { title: 'Documentação', icon: 'mdi-book-open-variant', to: '/docs' },
      ],
    }
  },
  computed: {
    userName() {
      const user = authService.getUser()
      return user ? user.name : ''
    },
    userInitials() {
      const user = authService.getUser()
      if (!user) return ''
      return user.name.split(' ').map((n) => n[0]).join('').toUpperCase().substring(0, 2)
    },
  },
  methods: {
    isActive(path) { return this.$route.path === path },
    logout() { authService.logout(); this.$router.push('/login') },
  },
}
</script>

<style>
.app-bg {
  background: #1A1F2E !important;
}

.sidebar {
  background: #1E2230 !important;
  border-right: 1px solid rgba(255, 255, 255, 0.04) !important;
}

.topbar {
  background: #1E2230 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04) !important;
}

.main-bg {
  background: #1A1F2E !important;
}

/* Nav items */
.nav-item {
  border-radius: 8px !important;
  min-height: 40px !important;
  transition: all 0.15s ease;
}

.nav-item .v-list-item__icon .v-icon {
  color: #6B7280 !important;
}

.nav-item .v-list-item__title {
  color: #9CA3AF !important;
  font-size: 13px !important;
}

.nav-item:hover {
  background: rgba(45, 212, 160, 0.06) !important;
}

.nav-item:hover .v-icon,
.nav-item:hover .v-list-item__title {
  color: #D1D5DB !important;
}

.nav-item--active {
  background: rgba(45, 212, 160, 0.12) !important;
}

.nav-item--active .v-list-item__icon .v-icon {
  color: #2DD4A0 !important;
}

.nav-item--active .v-list-item__title {
  color: #2DD4A0 !important;
  font-weight: 600 !important;
}

/* Cards */
.card-dark {
  background: #242936 !important;
  border: 1px solid rgba(255, 255, 255, 0.04) !important;
  border-radius: 14px !important;
}

.v-data-table {
  background: transparent !important;
}

.v-data-table th {
  color: #6B7280 !important;
  font-size: 12px !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style>
